import { CLASSNAME_HIDDEN } from '@vfde-brix/ws10/styles';

/**
 * Show/hide a HTML Element.
 *
 * @param element - HTML element or ID of an element.
 * @param isVisible - Show/hide the element.
 */
export const setElementVisibility = (element: HTMLElement | null | string, isVisible = true) => {
    const el = element instanceof HTMLElement ? element : document.getElementById(element || '');

    el?.classList.toggle(CLASSNAME_HIDDEN, !isVisible);
};

/**
 * Show/hide one or more HTML Elements.
 *
 * @param elements - HTML elements or IDs of the elements.
 * @param isVisible - Show/hide the elements.
 */
export const setElementsVisibility = (elements: (HTMLElement | null | string)[], isVisible = true) => {
    elements.forEach(element => setElementVisibility(element, isVisible));
};
